import { render, staticRenderFns } from "./AdminMenuNotice.vue?vue&type=template&id=0cc77f6f&"
import script from "./AdminMenuNotice.vue?vue&type=script&lang=js&"
export * from "./AdminMenuNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuNotice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminMenuNotice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports